import { useEffect } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { InfoBox } from "./InfoBox";
import { BillDataBox } from "./bill/BillDataBox";
import { BilledDataBox } from "./billed/BilledDataBox";
import { NoBillDataBox } from "./nobill/NoBillDataBox";
import { ActionTypeEnum, useDetailModel } from "./detailModel";
import { useGlobalModel } from "@/model/globalModel";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

/**
 * 内容区判断
 */
const DetailDataBox = () => {
    const { actionType } = useDetailModel();

    switch (actionType) {
        case ActionTypeEnum.BILLING_LIST:
            return <BillDataBox />;
        case ActionTypeEnum.BILLED_LIST:
            return <BilledDataBox />;
        case ActionTypeEnum.NO_BILL_LIST:
            return <NoBillDataBox />;
        default:
            return <></>
    }
}

export const InvoiceManageDetail = () => {

    const { setActionType } = useDetailModel();
    const { resourceAuth } = useGlobalModel(model => [model.resourceAuth]);

    useEffect(() => {
        //进入详情， 会去查有没有分配权限， 并取到第一个权限为展示
        setActionType(origin => {
            //所有tab权限
            let authArr = [
                ResourceAuthEnum.DATA_INVOICE_INVOICING_LIST,
                ResourceAuthEnum.DATA_INVOICE_INVOICING_BILLED,
                ResourceAuthEnum.DATA_INVOICE_INVOICING_APPLYLIST,
            ];
            //过滤出来所有分配的权限；
            let findAuth = resourceAuth.filter(item => authArr.indexOf(item as ResourceAuthEnum) >= 0);
            if (!findAuth.length) return ActionTypeEnum.NULL;
            if (findAuth.indexOf(ResourceAuthEnum.DATA_INVOICE_INVOICING_LIST) > -1) {
                return ActionTypeEnum.BILLING_LIST;
            }
            else if (findAuth.indexOf(ResourceAuthEnum.DATA_INVOICE_INVOICING_BILLED) > -1) {
                return ActionTypeEnum.BILLED_LIST;
            }
            else if (findAuth.indexOf(ResourceAuthEnum.DATA_INVOICE_INVOICING_APPLYLIST) > -1) {
                return ActionTypeEnum.NO_BILL_LIST;
            }
            else {
                return ActionTypeEnum.NULL;
            }
        });
    }, []);

    return (
        <>
            <YhPageHeader title="客户发票详情" />
            <InfoBox />
            <DetailDataBox />
        </>
    )
}